module.exports = __webpack_public_path__ + "media/images/signup-icons-90f595f2b2ad02b56142550d5374f69e.jpg";